import { dayjs, TimeDesTools } from "utils";

export const formatRelativeTime = (timeStamp?: number) => {
  if (!timeStamp) {
    return "";
  }
  const time = TimeDesTools.diffNow(timeStamp);
  const h24 = 24 * 60 * 60;
  const h48 = 48 * 60 * 60;
  if (time < h24) {
    return TimeDesTools.diffNowDes(timeStamp) + " ago";
  }
  if (time < h48) {
    return "Yesterday";
  }
  return dayjs(timeStamp).format("MMMM D");
};
